import { Box } from '@chakra-ui/react';
import { TextRegular } from 'UiKit/typography';

import styles from './styles.module.css';

const BadgeInactiveHost = ({ count }) => {
  return (
    <Box className={styles['badge__container']}>
      <TextRegular className={styles['badge__text--count']}>{count}</TextRegular>
    </Box>
  );
};

export default BadgeInactiveHost;
